import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "widget-time-tracker__task-info" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "widget-time-tracker__inputs-wrapper widget-time-tracker__inputs-wrapper--disabled" }
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButtonMini = _resolveComponent("AppButtonMini")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["widget-time-tracker", {
      'app-time-tracker--running': _ctx.trackingState
    }])
  }, [
    _createVNode(_component_AppButtonMini, {
      icon: _ctx.trackingState ? 'stop' : 'play',
      onClick: _ctx.stopTimer
    }, null, 8, ["icon", "onClick"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        innerHTML: _ctx.trackingEntity.task.text
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          id: "widget:time-tracker-hours",
          value: _ctx.leadingZero(_ctx.trackingEntity.timer.hours),
          readonly: ""
        }, null, 8, _hoisted_4),
        _hoisted_5,
        _createElementVNode("input", {
          id: "widget:time-tracker-minutes",
          value: _ctx.leadingZero(_ctx.trackingEntity.timer.minutes),
          readonly: ""
        }, null, 8, _hoisted_6),
        _hoisted_7,
        _createElementVNode("input", {
          id: "widget:time-tracker-seconds",
          value: _ctx.leadingZero(_ctx.trackingEntity.timer.seconds),
          readonly: ""
        }, null, 8, _hoisted_8)
      ])
    ])
  ], 2))
}